module.exports = __webpack_public_path__ + "img/ATRC Platform - Privacy Policy -4.b49654ef.png";